import {
  Edit,
  FileDownload,
  MoreVert,
  RemoveRedEye,
  Grading,
  Add,
  Email,
} from "@mui/icons-material";
import { IconButton, Menu } from "@mui/material";
import React from "react";
import DownloadCsv from "../../download_file/DownloadCsv";
import commonImages, { inspection } from "../../../assets";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";

export default function ReportRowManipulte(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dowloadCsv = React.useRef();
  const {
    rows: { row },
    viewOnClick,
    editOnClick,
    addForm,
    deleteOnClick,
    edit,
    download,
    view,
    deleted,
    addBtn,
    addBtnLabel = "Add",
    editLabel = "Edit Incident",
    deleteLabel = "Delete Incident",
    downloadLable = "Download Report",
    viewLabel = "View Incident",
    manageLabel = "Manage Inspection Authority",
    openLink,
    openLinkLabel = "Link",
    openLinkUrl,
    configure = false,
    configureLabel,
    configureOnClick,
    safetyLog = false,
    safetyLogOnClick,
    safetyLogLabel = "Safety Log",
    clone = false,
    cloneOnClick,
    manage = false,
    manageOnClick,
    sampleLog = false,
    sampleLogOnClick,
    sampleLogLabel = "Add Sample",
    missed = false,
    missedOnClick,
    missedLabel,
    conductExternal = false,
    conductExternalOnClick,
    conductExternalLabel,
    addProof = false,
    addProofOnClick,
    addProofLabel,
    resendEmailOnClick,
    resendEmailLable,
    resendEmail = false,
    sendEmailOnClick,
    sendEmailLable,
    sendEmail = false,
    defer = false,
    deferOnClick,
    deferLabel,
    unAssignLesson = false,
    unAssignLessonOnclick,
    unAssignLessonLabel,
    className,
    verifyEmail,
    verifyEmailOnClick,
    verifyEmailLable,
    convertToNonPreUserLabel,
    convertToNonPreUser,
    convertToNonPreUserOnClick,
    reportHistory = false,
    reportHistoryOnClick,
    reportHistoryLable,
    editProject = false,
    editProjectOnClick,
    editProjectLabel,
    viewProject = false,
    viewProjectOnClick,
    viewProjectLabel,
  } = props;
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  if (row?.status === 0 || row?.status === 3) {
    return null;
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="setting-menu"
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <div
          className={
            className
              ? `${className + " setting_button_ui"}`
              : "setting_button_ui"
          }
        >
          <div className="dropdownList_ui">
            <ul>
              {view && (
                <li onClick={() => viewOnClick(row)}>
                  <>
                    <RemoveRedEye /> <span>{viewLabel}</span>
                  </>
                </li>
              )}

              {openLink && (
                <li>
                  <div
                    onClick={() => {
                      window.open(openLinkUrl, "_blank");
                    }}
                    className="downloadresourse"
                  >
                    <FileDownload /> <span>{openLinkLabel}</span>
                  </div>
                </li>
              )}

              {edit && (
                <li onClick={() => editOnClick(row)}>
                  <Edit /> <span>{editLabel}</span>
                </li>
              )}

              {safetyLog && (
                <li onClick={() => safetyLogOnClick(row)}>
                  <Grading /> <span>{safetyLogLabel}</span>
                </li>
              )}

              {configure && (
                <li onClick={() => configureOnClick(row)}>
                  <Edit /> <span>{configureLabel}</span>
                </li>
              )}
              {download && (
                <li onClick={() => dowloadCsv.current.link.click()}>
                  <FileDownload /> <span>{downloadLable}</span>
                </li>
              )}
              {resendEmail && (
                <li onClick={() => resendEmailOnClick(row)}>
                  <RestartAltIcon /> <span>{resendEmailLable}</span>
                </li>
              )}
              {addBtn && (
                <li onClick={() => addForm(row)}>
                  <Add /> <span>{addBtnLabel}</span>
                </li>
              )}
              {sampleLog && (
                <li onClick={() => sampleLogOnClick(row)}>
                  <Add /> <span>{sampleLogLabel}</span>
                </li>
              )}
              {missed && (
                <li onClick={() => missedOnClick(row)}>
                  <>
                    <img
                      src={commonImages.missedIcon}
                      className="deleteImg"
                      alt=""
                    />{" "}
                    <span>{missedLabel}</span>
                  </>
                </li>
              )}
              {defer && (
                <li onClick={() => deferOnClick(row)}>
                  <>
                    <img
                      src={commonImages.deferIcon}
                      className="deleteImg"
                      alt=""
                    />{" "}
                    <span>{deferLabel}</span>
                  </>
                </li>
              )}
              {deleted && (
                <li onClick={() => deleteOnClick(row)} className="deleteIcon">
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.83331 15.5C2.37498 15.5 1.98276 15.3369 1.65665 15.0108C1.32998 14.6842 1.16665 14.2917 1.16665 13.8333V3H0.333313V1.33333H4.49998V0.5H9.49998V1.33333H13.6666V3H12.8333V13.8333C12.8333 14.2917 12.6703 14.6842 12.3441 15.0108C12.0175 15.3369 11.625 15.5 11.1666 15.5H2.83331ZM4.49998 12.1667H6.16665V4.66667H4.49998V12.1667ZM7.83331 12.1667H9.49998V4.66667H7.83331V12.1667Z"
                      fill="#1B436E"
                    />
                  </svg>
                  <span>{deleteLabel}</span>
                </li>
              )}
              {sendEmail && (
                <li onClick={() => sendEmailOnClick(row)}>
                  <Email />
                  <span>{sendEmailLable}</span>
                </li>
              )}
              {reportHistory && (
                <li onClick={() => reportHistoryOnClick(row)}>
                  <>
                    <RemoveRedEye /> <span>{reportHistoryLable}</span>
                  </>
                </li>
              )}
              {manage && (
                <li onClick={() => manageOnClick(row)}>
                  <img
                    src={commonImages.ManageIcon}
                    className="deleteImg"
                    alt=""
                  />

                  <span>{manageLabel}</span>
                </li>
              )}
              {clone && (
                <li onClick={() => cloneOnClick(row)}>
                  <img
                    src={commonImages.contentcopy}
                    className="deleteImg"
                    alt=""
                  />
                  <span>{props?.cloneLabel}</span>
                </li>
              )}

              {conductExternal && (
                <li onClick={() => conductExternalOnClick(row)}>
                  <img
                    src={inspection?.conductExternal}
                    className="conductExternal"
                    alt=""
                  />
                  <span>{conductExternalLabel}</span>
                </li>
              )}

              {addProof && (
                <li onClick={() => addProofOnClick(row)}>
                  <img
                    src={inspection?.conductExternal}
                    className="conductExternal"
                    alt=""
                  />
                  <span>{addProofLabel}</span>
                </li>
              )}
              {unAssignLesson && (
                <li onClick={() => unAssignLessonOnclick(row)}>
                  <AssignmentReturnIcon />
                  <span>{unAssignLessonLabel}</span>
                </li>
              )}
              {verifyEmail && (
                <li onClick={() => verifyEmailOnClick(row)}>
                  <RestartAltIcon /> <span>{verifyEmailLable}</span>
                </li>
              )}
              {convertToNonPreUser && (
                <li onClick={() => convertToNonPreUserOnClick(row)}>
                  <RestartAltIcon /> <span>{convertToNonPreUserLabel}</span>
                </li>
              )}
              {editProject && (
                <li onClick={() => editProjectOnClick(row)}>
                  <Edit /> <span>{editProjectLabel}</span>
                </li>
              )}

              {viewProject && (
                <li onClick={() => viewProjectOnClick(row)}>
                  <RemoveRedEye /> <span>{viewProjectLabel}</span>
                </li>
              )}
            </ul>
          </div>
        </div>
      </Menu>
      <DownloadCsv
        ref={dowloadCsv}
        data={[row ? row : []]}
        filename={"list-of-incident.csv"}
      />
    </>
  );
}
